<template>
  <div class="container">
    <div class="row mt-3">
      <div class="col-5">
        <h5>Cabecera (modelo temporal-2)</h5>
        <div>
          <input placeholder="id" v-model.number="modelo.id" class="form-control w-50 mb-1" type="text">
          <input placeholder="año" v-model.trim="modelo.anio" class="form-control w-50 mb-1" type="text">
          <input placeholder="titulo" v-model.trim="modelo.titulo" class="form-control w-50 mb-1" type="text">
          <!-- <input placeholder="pieTitulo" v-model.trim="modelo.pieTitulo" class="form-control w-50 mb-1" type="text"> -->
          <input placeholder="descripcion" v-model.trim="modelo.descripcion" class="form-control w-50 mb-1" type="text">
          <input placeholder="fecha" v-model.trim="modelo.fecha_actualizacion" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_word" v-model.trim="modelo.url_word" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_excel" v-model.trim="modelo.url_excel" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_comprimido" v-model.trim="modelo.url_comprimido" class="form-control w-50 mb-1" type="text">
        </div>

        <div class="mt-7">
          <h5>Contenido</h5>
          <input placeholder="idContenido" v-model.number="contenidoList.idContenido" class="form-control w-50 mb-1" type="text">
          <input placeholder="titulo" v-model.trim="contenidoList.titulo" class="form-control w-50 mb-1" type="text">
          <!-- <input placeholder="pieTitulo" v-model.trim="contenidoList.pieTitulo" class="form-control w-50 mb-1" type="text"> -->
          <input placeholder="descripcion" v-model.trim="contenidoList.descripcion" class="form-control w-50 mb-1" type="text">
          <input placeholder="link" v-model.trim="contenidoList.link" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_pdf" v-model.trim="contenidoList.url_pdf" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_word" v-model.trim="contenidoList.url_word" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_excel" v-model.trim="contenidoList.url_excel" class="form-control w-50 mb-1" type="text">
          <input placeholder="url_comprimido" v-model.trim="contenidoList.url_comprimido" class="form-control w-50 mb-1" type="text">
          <button @click="armarElemento()" type="button" class="btn btn-success btn-largo">push</button>
          <button @click="reset()" type="button" class="btn btn-secondary btn-largo mt-5">Borrar todo</button>
        </div>
      </div>
      <div class="col-6 toScroll">
        <pre class="text-danger">{{ modelo }}</pre>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'correccion',
    mounted(){
      // this.contenidoList.idSeccion = 1;
    },
    data() {
        return {
          contador: 1,
          modelo:{
            "id": 0,
            "anio": 0,
            "titulo": "",
            "descripcion": "",
            "propietario_documento": "",
            "fecha_actualizacion": "2009-10-21",
            "contenido": []
          },
          contenidoList: {
            "idContenido": 1,
            "titulo": "",
            "descripcion": "",
            "link": "",
            "url_pdf": "",
            "url_word": "",
            "url_excel": "",
            "url_comprimido": ""
          },
        };
    },
    methods: {
      armarElemento(){
        this.modelo.contenido.push(this.contenidoList);
        this.contenidoList = {
            "idContenido": this.contador+1,
            "titulo": "",
            "pieTitulo": "",
            "descripcion": "",
            "link": "",
            "url_pdf": "",
            "url_word": "",
            "url_excel": "",
            "url_comprimido": ""
          }
          this.contador +=1;

          // if(this.contador == 2) this.contenidoList.titulo = "2do trimestre";
          // if(this.contador == 3) this.contenidoList.titulo = "3er trimestre";
          // if(this.contador == 4) this.contenidoList.titulo = "4to trimestre";


      },
      reset(){
        this.modelo = {
          "id": 0,
            "anio": 0,
            "titulo": "",
            "pieTitulo": "",
            "descripcion": "",
            "propietario_documento": "",
            "fecha_actualizacion": "2009-10-21",
            "contenido": []
            },
          this.contenidoList = {
            "idContenido": 1,
            "titulo": "",
            "pieTitulo": "",
            "descripcion": "",
            "link": "",
            "url_pdf": "",
            "url_word": "",
            "url_excel": "",
            "url_comprimido": ""
          }
          this.contador = 1;
      }
    }
}



</script>
<style scoped>
.form-control {height: 1.4rem !important;}
.btn-largo{
  padding-left: 30px !important;
  padding-right: 30px !important;
  display: block;
  margin-top: .5rem;
}
.toScroll {
  height:100vh;
  overflow-y: scroll;
}
</style>
